"use client";

import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import axios from "axios";
import "swiper/css";

export default function AlumniWorkplace() {
  const [alumniData, setAlumniData] = useState([]);
  const swiperRef = useRef(null); // Fixed the useRef type

  const AIRTABLE_URL = process.env.REACT_APP_AIRTABLE_URL;
  const AIRTABLE_TOKEN = process.env.REACT_APP_AIRTABLE_TOKEN;

  // Fetch alumni data
  useEffect(() => {
    async function fetchAlumniData() {
      try {
        const response = await axios.get(`${AIRTABLE_URL}/alumni`, {
          headers: {
            Authorization: `Bearer ${AIRTABLE_TOKEN}`,
          },
        });
        setAlumniData(response.data.records);
      } catch (error) {
        console.error("Error fetching alumni data:", error);
      }
    }

    fetchAlumniData();
  }, []);

  return (
   
      <div
        style={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        {/* Navigation Buttons */}
        <button
          style={{
            position: "absolute",
            top: "50%",
            left: "-4%",
            transform: "translateY(-50%)",
            backgroundColor: "transparent",
            border: "none",
            cursor: "pointer",
          }}
          onClick={() => swiperRef.current?.slidePrev()}
        >
          <IoIosArrowBack style={{ color: "#FF9900", fontSize: "2rem" }} />
        </button>

        <button
          style={{
            position: "absolute",
            top: "50%",
            right: "-4%",
            transform: "translateY(-50%)",
            backgroundColor: "transparent",
            border: "none",
            cursor: "pointer",
          }}
          onClick={() => swiperRef.current?.slideNext()}
        >
          <IoIosArrowForward style={{ color: "#FF9900", fontSize: "2rem" }} />
        </button>

        {/* Swiper Carousel */}
        <Swiper
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
          spaceBetween={20}
          slidesPerView={1}
          loop={true}
          speed={800}
          breakpoints={{
            480: { slidesPerView: 1 },   // Small screens (mobile)
            640: { slidesPerView: 2 },   // Medium screens (small tablets)
            768: { slidesPerView: 2 },   // Large tablets
            1024: { slidesPerView: 3 },  // Small desktops
            1280: { slidesPerView: 4},  //
            1400:{slidesPerView : 5}
          }}
          className="flex px-4 py-4 justify-center items-center"
        >
          {alumniData.map((alumni, index) => (
            <SwiperSlide key={index}>
              <div
              className="w-[227px] h-[245px] shadow mx-auto flex flex-col items-center justify-center bg-white rounded-lg p-4 transition-transform duration-300 hover:scale-105 hover:shadow-lg hover:bg-BgPrimaryWhite border border-secondary-color"
                             >
                <img
                  src={alumni.fields.photo[0]?.thumbnails?.full?.url}
                  alt={alumni.fields.name}
                  style={{
                    borderRadius: "50%",
                    objectFit: "cover",
                    width: "100px",
                    height: "100px",
                  }}
                />
                <h4 className="text-gray-600 font-medium my-4">
                  {alumni.fields.name}
                </h4>
                <img
                  src={alumni.fields["company-logo"][0]?.thumbnails?.full?.url}
                  alt={alumni.fields["company-name"]}
                  style={{ width: "auto", height: "40px" }}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

  );
}
